var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#25D366"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.26 18.335-.418.44s-.992 1.045-3.7-1.807c-2.71-2.852-1.717-3.897-1.717-3.897l.263-.277c.647-.681.708-1.776.143-2.575l-1.155-1.635c-.7-.99-2.051-1.12-2.853-.276L8.384 9.823c-.397.418-.664.96-.631 1.562.082 1.54.74 4.852 4.411 8.717 3.893 4.099 7.546 4.262 9.04 4.114.472-.047.883-.301 1.214-.65l1.302-1.37c.879-.926.631-2.513-.494-3.16l-1.75-1.008a1.79 1.79 0 0 0-2.216.307"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.869c8c7325f0c9568883fc98ee0d880d.svg";
export { ForwardRef as ReactComponent };